module.exports = __webpack_public_path__ + "static/media/neuronet@2x.5a511726.png";